@if (isClubHub || isIgnite) {
  <div
    class="bg-colour-grayscale-100 pb-5"
    >
    @if (isClubHub) {
      <div
        class="overflow-hidden bg-colour-blue-700 text-white px-5"
        >
        <div class="container my-4">
          <h1 class="clubhub-home-header-title">
            Welcome to ClubHub
          </h1>
          <p class="mt-4 clubhub-home-header-text">
            Here you will find all the information you need to make the most of your partnership with us.
          </p>
          <p class="clubhub-home-header-text">
            You will have access to member only content and exclusives, giving you a better view of what is available to you
            as a Mortgage Club partner.
          </p>
        </div>
      </div>
    }
    <div class="position-relative">
      <div
        class="position-absolute top-0 w-100 bg-colour-blue-700 text-white"
        [style.height]="'150px'"
        >
      </div>
      <div class="position-relative">
        <div class="container">
          <div class="card border border-2 border-colour-blue-600 rounded-3 p-3">
            <div class="d-flex">
              <h2 class="flex-fill clubhub-home-header-title mb-0">Ignite</h2>
              <a
                routerLink="/ignite"
                class="btn btn-colour-blue-600 px-3 py-2 align-self-center rounded-1"
                >
                Start using Ignite
              </a>
            </div>
            <h3 class="clubhub-home-header-text my-4">
              Fuel right-first time results with our seamless, intuitive sourcing platform that works the way you do.
            </h3>
            <p>
              Ignite, provides access to all the research and sourcing tools you need, to find your
              client the most appropriate mortgage.
            </p>
            <p>
              Access Criteria, Affordability, Product Sourcing and Property Check tools from one easy to use platform.
            </p>
            <p>
              Perform whole-of-market comparisons, and provide your clients with reliable, real-time results from our
              broad base of lenders and products, whatever their circumstances.
            </p>
            <div>
              <span class="fw-bold">Key features:</span>
              <ul class="mt-2">
                <li class="mb-2">
                  Use our tools in insolation or seamlessly blend to build an accurate picture for your client without
                  having to log into different systems.
                </li>
                <li class="mb-2">
                  Download compliant ESIS and Evidence of Research documents from our product sourcing tool.
                </li>
                <li class="mb-2">
                  Manage complex cases including self-employed, joint borrowers and sole proprietors and enter income and
                  expenditure for up to 4 mortgage applicants.
                </li>
                <li class="mb-2">
                  Make your search greener and access EPC information with ease from our property check tool.
                </li>
                <li class="mb-2">
                  Access over 130 lenders across all lending types including bridging, second charge and packager.
                </li>
              </ul>
              <span>
                For a no obligation demonstration, pop on to live chat and request with a member of our friendly MSS team.
              </span>
            </div>
          </div>
        </div>
        @if (isClubHub) {
          <div
            class="my-4"
            >
            <lib-banner
              maxWidth="unset"
              [bannerName]="bannerName"
              />
          </div>
        }
        @if (isClubHub) {
          <div
            class="container"
            >
            <div class="d-flex gap-2">
              <div class="card border rounded-1 p-3 d-flex flex-column">
                <h2>Procuration fees</h2>
                <p>
                  We are the only Mortgage Club that pays your procuration fee on exchange,
                  allowing you to have greater control over your cash flow.
                </p>
                <p>
                  All you need to do is notify us of your cases at exchange stage via our digital claim form here in
                  ClubHub, and we will arrange payment on your next available commission statement.
                </p>
                <a
                  class="mb-3"
                  href="assets/documents/Mortgage ClubHub - Proc Fee Guide.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  >
                  Claims guide (PDF)
                </a>
                <a
                  class="btn btn-outline-colour-grayscale-900 mt-auto"
                  routerLink="/procfee/newclaim"
                  >
                  Claim your proc fees
                </a>
              </div>
              <div class="card border rounded-1 p-3 d-flex flex-column">
                <h2>Events</h2>
                <p>
                  Our popular UK-wide events programme is designed to help you grow your business by keeping you updated on
                  the latest market & industry information. Register today to secure your place.
                </p>
                <a
                  class="btn btn-outline-colour-grayscale-900 mt-auto"
                  href="https://www.legalandgeneral.com/adviser/mortgage-club/events/?cid=PartnerSite18342"
                  target="_blank"
                  rel="noopener noreferrer"
                  >
                  Upcoming events
                </a>
              </div>
              <div class="card border rounded-1 p-3 d-flex flex-column">
                <h2>Adviser academy</h2>
                <p>
                  Within our adviser academy you can find a number of educational webinars and videos, on a variety of
                  topics in the mortgage market.
                </p>
                <p>
                  You can also access a suite of marketing toolkits which include templates, images and guides to help
                  promote your services to your customers.
                </p>
                <a
                  class="btn btn-outline-colour-grayscale-900 mt-auto"
                  href="https://www.legalandgeneral.com/adviser/mortgage-club/Adviser-Academy/#marketing-toolkits"
                  target="_blank"
                  rel="noopener noreferrer"
                  >
                  Adviser academy
                </a>
              </div>
            </div>
            <div class="card border rounded-1 p-3 mt-3">
              <h2>Can’t find what you need?</h2>
              <p>
                Further support is available via our Mortgage Support Services on
                <strong>{{ contactUsPhone.text }}</strong>*. Lines are open
                between 9.30am - 4.30pm.
              </p>
              <p>
                Alternatively, you can chat to us via Live Chat which is available on our website.
              </p>
              <small>*We may record and monitor calls and call charges will vary.</small>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
